"use client";

import { useState, type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SessionProvider } from "next-auth/react";
import { ApiError } from "@/lib/n8n/client";

export function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Un cockpit qui affiche des impayés périmés serait pire qu'un
            // cockpit vide : on privilégie la fraîcheur au confort de cache.
            staleTime: 30 * 1000,
            refetchOnWindowFocus: true,
            retry: (failureCount, error) => {
              // Inutile d'insister sur un refus de droits ou un objet absent.
              if (error instanceof ApiError &&
                  ["FORBIDDEN", "UNAUTHORIZED", "NOT_FOUND"].includes(error.code)) {
                return false;
              }
              return failureCount < 2;
            },
          },
        },
      }),
  );

  return (
    <SessionProvider>
      <QueryClientProvider client={client}>{children}</QueryClientProvider>
    </SessionProvider>
  );
}
